<template>
  <div class="entrance">
    <div class="entrance-task">
      <div
        v-for="(item, index) in taskList"
        :key="index"
        class="task-one"
        :class="item.process ? 'finished' : index === 1 ? 'ing' : ''"
      >
        {{ index + 1 }}.{{ item.name }}
        <div class="box">
          <div v-if="!item.process"></div>
          <i v-else class="icon iconfont icon-duigou" style="color: #fff"></i>
        </div>
      </div>
      <!-- <div class="task-one">
        完成
        <div class="box"><div></div></div>
      </div> -->
      <div class="line"></div>
    </div>
    <div class="entrance-header">
      <p>参展申请</p>
      <span></span>
      <p>选择展会及展位类型</p>
    </div>

    <div class="entrance-list" v-if="list && list.length > 0">
      <div v-for="(item, index) in list" :key="index">
        <div class="list-one" :class="index % 2 !== 0 ? 'gray' : ''">
          <div>
            <img
              :src="item.logo"
              alt=""
              style="width: 40px; height: 40px; margin-right: 10px"
            />
          </div>
          <div class="text">
            <p>{{ item.name }}</p>
            <p style="color: red; font-size: 16px">
              {{ item.startTime | moment("YYYY/MM/DD") }}~{{
                item.endTime | moment("MM/DD")
              }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.exHall }}
            </p>
          </div>
          <div style="display: flex">
            <div
              class="btn"
              style="margin-right: 20px"
              @click="apply(item, '否')"
            >
              直销展位报名
            </div>
            <!-- <div class="btn second" @click="getBoothGroup(item,index)">展团报名</div> -->
          </div>
        </div>
        <div class="group" v-if="item.groupList && item.groupList.length > 0">
          <div
            v-for="(itm, idx) in item.groupList"
            :key="idx"
            class="group-box"
          >
            <div class="group-1">{{ itm.name }}</div>
            <div class="group-2" @click="applyGroup(item, itm)">
              加入<br />
              {{ itm.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="line-height: 500px; text-align: center">暂无数据！</div>

    <div class="entrance-btn">
      <Button type="primary" size="large" class="s-btn-red" @click="goBack"
        >上一步</Button
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "entrance", // 参展申请 - 入口
  data() {
    return {
      taskList: [],
      speenInfo: null,
        list: [],

        exhibitionSetting: {
            // "0d236e01-c698-4ebd-9b17-fa2687d43a65": { order: 1, name: "2026春" },
            // "fdfcbf63-68f8-4be7-8e63-6dff02a54b4d": { order: 2, name: "40" },
            // "39eb2110-203f-4036-ad52-27b345b5129c": { order: 3, name: "93" },
            // "868a0e65-70de-4027-ac46-67c221687962": { order: 4, name: "2026秋康复" },
            // "000fe5f1-fd58-4cee-9946-d07fdf799347": { order: 5, name: "41届ICMD" },
            // "e26c62a6-de1c-407b-979f-e1ea75211c22": { order: 6, name: "94届CMEF" },
            "aa19867d-a9ec-4fff-872d-b39c9c40d276": { order: 1, name: "95届CMEF" },
            "c2a06a24-50ca-4857-b351-7c19329237a3": { order: 2, name: "42届ICMD" },
            "e9d654fc-6aef-420e-9992-6188f2324b4f": { order: 3, name: "2027春康复" },
        }

        
    };
  },
  components: {},
  computed: {
    applyCompanyId() {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId() {
      return this.$route.query.applyCompanyOrderId;
      },
      ...mapGetters({
      }),

  },
  methods: {
    ...mapActions({
      getApplyFlow: "getApplyFlow",
      getApplyFlowSpeed: "getApplyFlowSpeed",
      getApplyExhibition: "getApplyExhibition",
      applyCompanyOrder: "applyCompanyOrder",
      editCompanyOrder: "editCompanyOrder",
      getGroup: "getGroup",
    }),
    async init() {
      // 流程
      let taskList = await this.getApplyFlow();
      this.taskList = taskList;

      let info = await this.getApplyFlowSpeed(this.applyCompanyId);
      if (info && info.info) {
        this.speenInfo = info.info;
        if (this.taskList && this.taskList.length > 0) {
          this.taskList.map((c) => {
            if (this.speenInfo && this.speenInfo.speed >= c.speed) {
              c.process = true;
            }
          });
        }
      }
      // this.speenInfo不存在，即此轮流程已结束
      if (!this.speenInfo) {
        if (this.applyCompanyOrderId) {
          this.$router.push(
            "/join/basic?applyCompanyId=" +
              this.applyCompanyId +
              "&applyCompanyOrderId=" +
              this.applyCompanyOrderId
          );
        } else {
          this.$router.push(
            "/join/basic?applyCompanyId=" + this.applyCompanyId
          );
        }
      }
        // 允许展示的展会 ID 及排序权重（越小的越靠前）
        const exhibitionMeta = this.exhibitionSetting
      const allExhibitions = await this.getApplyExhibition();

      // 过滤 + 排序
      this.list = allExhibitions
        .filter(e => exhibitionMeta[e.id])
        .sort((a, b) => exhibitionMeta[a.id].order - exhibitionMeta[b.id].order);
        
    },
    goBack() {
      if (this.applyCompanyOrderId) {
        this.$router.push(
          "/join/basic?applyCompanyId=" +
            this.applyCompanyId +
            "&applyCompanyOrderId=" +
            this.applyCompanyOrderId
        );
      } else {
        this.$router.push("/join/basic?applyCompanyId=" + this.applyCompanyId);
      }
    },
    async apply(e, isAgent) {
      console.log(isAgent, "isAgent");
      let req = {
        ApplyCompanyId: this.applyCompanyId,
        ExhibitionId: e.id,
        IsAgent: isAgent,
        AgentName: "",
      };
      if (this.speenInfo.speed < 2) {
        let bool = await this.applyCompanyOrder(req);
        if (bool && bool.successed) {
          this.$router.push(
            "/join/order?id=" +
              e.id +
              "&applyCompanyId=" +
              this.applyCompanyId +
              "&applyCompanyOrderId=" +
              bool.info.id
          );
        } else {
          this.$Message.warning("您已完成报名请耐心等待组委会通知");
        }
      } else {
        let bool = await this.editCompanyOrder({
          ...{ Id: this.speenInfo.applyCompanyOrderId },
          ...req,
        });
        if (bool && bool.successed) {
          this.$router.push(
            "/join/order?id=" +
              e.id +
              "&applyCompanyId=" +
              this.applyCompanyId +
              "&applyCompanyOrderId=" +
              this.speenInfo.applyCompanyOrderId
          );
        } else {
          this.$Message.warning("您已完成报名请耐心等待组委会通知");
        }
      }
    },
    async applyGroup(e, itm) {
      let req = {
        ApplyCompanyId: this.applyCompanyId,
        ExhibitionId: e.id,
        IsAgent: "是",
        AgentName: itm.name,
      };
      if (this.speenInfo.speed < 2) {
        let bool = await this.applyCompanyOrder(req);
        if (bool && bool.successed) {
          this.$router.push(
            "/join/order?id=" +
              e.id +
              "&applyCompanyId=" +
              this.applyCompanyId +
              "&applyCompanyOrderId=" +
              bool.info.id +
              "&groupId=" +
              itm.id
          );
        } else {
          this.$Message.warning("您已完成报名请耐心等待组委会通知");
        }
      } else {
        let bool = await this.editCompanyOrder({
          ...{ Id: this.speenInfo.applyCompanyOrderId },
          ...req,
        });
        if (bool && bool.successed) {
          this.$router.push(
            "/join/order?id=" +
              e.id +
              "&applyCompanyId=" +
              this.applyCompanyId +
              "&applyCompanyOrderId=" +
              this.speenInfo.applyCompanyOrderId +
              "&groupId=" +
              itm.id
          );
        } else {
          this.$Message.warning("您已完成报名请耐心等待组委会通知");
        }
      }
    },
    async getBoothGroup(e, i) {
      let list = await this.getGroup(e.id);
      if (list && list.length > 0) {
        this.$set(this.list[i], "groupList", list);
      } else {
        this.$Message.warning("该展会暂无展团信息！");
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped lang='scss'>
.entrance {
  &-task {
    width: 100%;
    margin: 20px 0 50px;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    color: #666;
    position: relative;
    .task-one {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;
      .box {
        width: 20px;
        height: 20px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0px #00bdca59;
        border-radius: 50%;
        margin-top: 10px;
        div {
          width: 14px;
          height: 14px;
          background-color: #8ba5bc;
          border-radius: 50%;
          margin: 3px auto 0;
        }
      }
    }
    .line {
      height: 8px;
      background-color: #d7e2e4;
      position: absolute;
      width: 998px;
      left: 108px;
      top: 37px;
      z-index: 1;
    }
    .ing {
      color: #00bdca;
      .box {
        div {
          background-color: #00bdca;
        }
      }
    }
    .finished {
      color: #00bdca;
      .box {
        background-color: #00bdca;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: #00bdca;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      line-height: 64px;
      font-size: 20px;
    }
    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-list {
    .list-one {
      width: 100%;
      height: 106px;
      background-color: #fff;
      padding: 0 30px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .text {
        width: calc(100% - 340px);
        padding-right: 30px;
        p {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #333;
        }
        p:first-child {
          font-size: 18px;
          font-weight: bold;
        }
        p:last-child {
          font-size: 14px;
        }
      }
      .btn {
        width: 160px;
        height: 46px;
        background-color: #00bdca;
        color: #fff;
        font-size: 16px;
        text-align: center;
        line-height: 46px;
        cursor: pointer;
      }
      .second {
        background-color: #fff;
        border: solid 1px #00bdca;
        color: #00bdca;
      }
    }
    .gray {
      background-color: #ededed;
    }
    .group {
      width: 100%;
      padding: 24px 10px 10px 24px;
      background-color: #fff;
      border-top: 1px solid #ededed;
      display: flex;
      flex-wrap: wrap;
      .group-box {
        text-align: center;
        cursor: pointer;
        font-size: 20px;
        margin: 0 14px 14px 0;
        position: relative;
        &:hover {
          .group-2 {
            visibility: visible;
          }
        }
      }
      .group-1 {
        line-height: 58px;
        padding: 0 40px;
        background-color: #f5f5f5;
        color: #333;
      }
      .group-2 {
        width: 100%;
        color: #fff;
        font-size: 16px;
        padding: 5px 40px;
        background-color: #024c8b;
        box-shadow: 1px 2px 5px 0px rgba(0, 49, 90, 0.6);
        position: absolute;
        top: 0;
        left: 0;
        visibility: hidden;
      }
    }
  }

  &-btn {
    margin-top: 50px;
    margin-bottom: 80px;
    text-align: center;
    button {
      width: 200px;
      height: 48px;
      background-color: #024c8b;
      font-size: 16px;
      border-color: #024c8b;
    }
  }
}
</style>